import React from 'react';
import { formatCheckedAtFull, formatCheckedDate, freshness } from '../derive';
import s from '../s.module.less';

type Props = {
    checkedAt: string;
    // 实际操作人（"Last checked by Sarah Kim · Aug 26 · 2 days ago"）；仅 practice 视图有值。
    // 空 → 回退纯时间标注（solo 视图 / SYSTEM_AUTO 触发）
    checkedBy?: string;
    // 10/21：下一行点名这次答的是哪张（"Aetna · Secondary insurance"）
    planScope?: string;
};

// FR0：last-checked 永远可见、不进折叠区。只有 staleness 是信号：stale 转琥珀且 age 加粗
const LastCheckedLine: React.FC<Props> = ({ checkedAt, checkedBy, planScope }) => {
    const f = freshness(checkedAt);
    const line = (
        <div className={`${s.lastChecked} ${f.stale ? s.lastCheckedStale : ''}`} title={formatCheckedAtFull(checkedAt)}>
            <span className={s.lcDot} />
            <span>
                Last checked {checkedBy ? `by ${checkedBy} · ` : ''}
                {formatCheckedDate(checkedAt)} · <em>{f.ageLabel}</em>
            </span>
        </div>
    );
    if (!planScope) return line;
    return (
        <div>
            {line}
            <div className={s.planScope}>{planScope}</div>
        </div>
    );
};

export default LastCheckedLine;
